import axios from '@/plugins/axios';

const CAMPAIGNS = '/campaigns';

export async function getCampaignByCode(payload) {
  try {
    const { data } = await axios.get(CAMPAIGNS, { params: payload });
    return data;
  } catch (err) {
    return { err };
  }
}
